module.exports = __webpack_public_path__ + "2deded74d5d55919373b4db0aa851ea6.svg";